// document.addEventListener("DOMContentLoaded", e => {
//     var top = document.querySelector(`.hero`);
//     var playButton = document.querySelector(`.hero__button`);

//     /* Scroll to top before playing the game */
//     playButton.addEventListener("click", function() {
//         top.scrollIntoView({ behavior: "smooth" });
//     });
// });
